export default __webpack_public_path__ + "static/media/abe-money.039970f3.png";